import React, {useState} from 'react';
import {connect} from 'react-redux';
import {startLoginService} from '../actions/auth';
import {onLoginServiceCalls} from '../actions/onLogin';

const Login = (props) => {

    const loginStates = {
        idle: "idle",
        loading: "loading",
        success: "success",
        failure: "failure"
    }
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [phoneError, setPhoneError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [loginStatus, setLoginStatus] = useState(loginStates.idle);

    const onPhoneChange = (e) => {
        if (!!e.target.value.match(/^[0-9]*$/))
            setPhone(e.target.value)
    }

    const onPasswordChange = (e) => {
        setPassword(e.target.value)
    }

    const onSignupClicked = () => {
        props.history.push('/signup')
    }

    const onForgotPassClicked = () => {
        props.history.push('/forgot-password')
    }

    const onLoginClicked = () => {
        let hasError = false
        if (phone === "" || !phone.match(/^09[0-9]{9}$/)){
            setPhoneError(true);
            hasError = true
        }
        else{
            setPhoneError(false);
        }
        if(password === ""){
            setPasswordError(true);
            hasError = true
        }
        else{
            setPasswordError(false);
        }

        if (!hasError){
            setLoginStatus(loginStates.loading)
            props.startLoginService(phone, password)
            .then(({
                success,
                error
            }) => {
                if (success) {
                    props.onLoginServiceCalls(success.body.token)
                    .then(({
                            success,
                            error
                        }) => {
                            if (success) {
                                setLoginStatus(loginStates.success)
                            } else {
                                if (!!error.status) {
                                    localStorage.removeItem('authToken');
                                }
                                setLoginStatus(loginStates.failure)
                            }
                        })
                        .catch(() => {
                            console.log("connection lost");
                        })
                    // props.history.goBack()
                } else {
                    setLoginStatus(loginStates.failure)
                }
            })
        }
    }

    return (
        <div className="container-fluid optimized__d-flex-class flex-column h-100 pt-0 px-0 pb-4 justify-content-start about">
            <div className="optimized__d-flex-class">
                <button className="btn__tab--active flex-grow-1">ورود</button>
                <button className="btn__tab flex-grow-1" onClick={onSignupClicked}>ثبت نام</button>
            </div>
            <div className="optimized__d-flex-class flex-column mx-4 mt-3 px-4 pb-4 about__description">
                <input className={`${phoneError ? "about__input--error" : "about__input"} p-3 mb-3 mt-4`} type="text" value={phone} onChange={onPhoneChange} placeholder="شماره همراه" />
                <input className={`${passwordError ? "about__input--error" : "about__input"} p-3 mb-4`} type="password" value={password} onChange={onPasswordChange} placeholder="رمز عبور" />
                <div className="optimized__d-flex-class justify-content-start mb-4">
                    <span className="about__link-text" onClick={onForgotPassClicked}>رمز عبور خود را فراموش کرده ام</span>
                </div>
                <button disabled={loginStatus === loginStates.loading} className="register__button py-4" onClick={onLoginClicked}>وارد شوید</button>
                {
                    loginStatus === loginStates.failure ? (
                        <span className="error-dialog mt-3 py-1">خطا در ورود به حساب کاربری</span>
                    ) : (undefined)
                }
            </div>
        </div>
    );
}

const mapDispatchToProps = (dispatch) => ({
    startLoginService: (phoneNo, password) => dispatch(startLoginService({phoneNo, password})),
    onLoginServiceCalls: (token) => dispatch(onLoginServiceCalls(token))
})

export default connect(undefined, mapDispatchToProps)(Login);